export default __webpack_public_path__ + "static/media/chemical-equilibrium-lab.0f9d1be4.png";